const binding = { modules: {}, dataActions: {} };

    (binding.modules['hei-promotion'] = {
        c: () => require('partner/modules/hei-promotion/hei-promotion.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hei-promotion',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hei-promotion'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hei-promotion|hei-promotion'] = {
                c: () => require('partner/modules/hei-promotion/hei-promotion.view.tsx'),
                cn: '__local__-__local__-hei-promotion'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };